<template>
  <div>
    <div>
      <div class="tasks-title-box w-100 rounded">
        <v-row class="ma-5">
          <v-col class="my-auto mx-auto mobile-d-none"><h3>اسلاید صفحه اصلی</h3></v-col>
          <v-col class="text-left" xs="12">
            <v-spacer></v-spacer>
          </v-col>
          <v-col class="text-left" xs="12">
            <v-btn class="elevation-0" large @click="create_view.dialog=true;">
              <v-icon small >mdi-plus</v-icon>
              <div class="mobile-d-none">افزودن اسلاید</div>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="last-changes rounded-lg container">
      <h2 class="text-center mb-3">اسلاید های ثبت شده</h2>
        <v-data-table
            dense
            :loading="loading_slides"
            hide-default-footer
            :headers="slides_table.headers"
            :items="slides_table.desserts"
            class="elevation-0"
        >

          <template v-slot:item.status="{ item }">
            <v-tooltip top color="gray" max-width="50em">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                       :color="item.status?'success':'red'"
                       @click="change_status_id=item.id;change_status(item.id)"
                       prepend-icon="mdi-vuetify"
                       rounded outlined
                       class="my-4"
                       :loading="change_status_id===item.id && change_status_btn_loading"
                >
                  <v-icon :color="item.status?'success':'red'">{{ item.status ? 'mdi-check' : 'mdi-close' }}</v-icon>
                </v-btn>
              </template>
              برای تغییر وضعیت کلیک کنید
            </v-tooltip>
          </template>

          <template v-slot:item.img="{ item }">
            <v-img :src="item.img" max-width="200px" class="my-3 mx-auto"></v-img>
          </template>

          <template v-slot:item.remove="{ item }">
            <v-btn
                prepend-icon="mdi-trash-can"
                class=" rounded-pill "
                color="error" text large
                @click="remove_view.slide=item;remove_view.dialog=true;"
            >
              حذف
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      <v-pagination
          v-if="slides_count > 10"
          v-model="page"
          color="#D20003"
          rounded
          @input="get_slides()"
          :length="slides_count%10!==0?parseInt(slides_count/10)+1:parseInt(slides_count/10)"
          :total-visible="7"
      ></v-pagination>
    </div>
    <v-dialog v-model="create_view.dialog" scrollable height="10vh" width="30em">
      <v-card>
        <v-card-title>
          <h3 class="mx-auto">افزودن اسلاید</h3>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <v-container>
            <v-file-input v-model="create_view.slide.img" rounded outlined label="تصویر اسلاید"></v-file-input>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding: 0 !important;" v-if="create_view.slide.img">
          <v-btn block large
                 class="elevation-0 rounded-0 text-bold"
                 color="success"
                 @click="create_slide()" :loading="create_view.loading">
            افزودن
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>
    <v-dialog
        v-if="remove_view.slide"
        v-model="remove_view.dialog"
        persistent
        max-width="500"
        class="br-1em"
    >
      <v-card class="br-1em">
        <v-card-title>
          <h3 class="mx-auto">
            آیا میخواهید این اسلاید را حذف کنید ؟
          </h3>
        </v-card-title>
        <v-card-actions class="text-center pb-5">
          <v-spacer></v-spacer>

          <v-btn
              color="green"
              @click="remove_view.dialog = false"
              large text
              class="elevation-0"
          >
            بازگشت
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              class="elevation-0"
              :loading="remove_view.loading"
              @click="remove_slide(remove_view.slide['id'])"
          >
            حذف
          </v-btn>
          <v-spacer></v-spacer>

        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'HomeManageSlide',
  data:()=>({
    key: localStorage.getItem('key'),
    create_ticket_dialog:false,
    loading_slides: false,
    ticket_form:{},
    search_items:[],
    search_field:null,
    slides_count:0,
    page:1,
    remove_view:{
      dialog: false,
      loading:false,
      slide:null,
    },
    change_status_id:null,
    create_view:{
      dialog: false,
      loading:false,
      slide: { img:null},
    },
    change_status_btn_loading:false,
    slides_table: {
      headers: [
        {text: 'شماره',align: 'center', value: 'id'},
        {text: 'عکس',align: 'center', value: 'img'},
        {text: 'وضعیت',align: 'center', value: 'status'},
        {text: 'حذف',align: 'center', value: 'remove'},
      ],
      desserts:[],
    },
  }),
  created() {
    this.get_slides();
  },
  methods:{
    async get_slides(){
      this.loading_slides = true;
      try {
        const response = await axios.get(`${this.BACKEND_LINK}/api/account-admin/home-slides/?page=${this.page}`,{
          headers: {'Authorization': `Token ${this.key}`}
        });
        if (response.data){
          this.slides_count = response.data.count;
          this.slides_table.desserts = response.data.results;
        }
      } catch (error) {
        this.$snotify.error(`در دریافت مشکلی به وجود آمد. کد : ${error.response.status}`, 'دریافت اطلاعات');
      } finally {
        this.loading_slides = false;
      }
    },
    change_status(id){
      this.change_status_btn_loading = true;
      axios.put(`${this.BACKEND_LINK}/api/account-admin/home-slides/change-status/${id}`,{},{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        if(response.data.status) {
          this.$snotify.success(response.data.msg, 'تغییر وضعیت');
          this.get_slides();
        }
        else {
          this.$snotify.error(`در تغییر وضعیت مشکلی به وجود آمد. کد : ${response.status}`, 'تغییر وضعیت');
        }
        this.change_status_btn_loading = false;
      }).catch((error)=>{
        this.$snotify.error(`در تغییر وضعیت مشکلی به وجود آمد. کد : ${error.response.status}`, 'تغییر وضعیت');
        this.change_status_btn_loading = false;
      })
    },
    remove_slide(id){
      this.remove_view.loading = true;
      axios.delete(`${this.BACKEND_LINK}/api/account-admin/home-slides/change-status/${id}`,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        if (response.status === 204) {
          this.$snotify.success(`اسلاید با موفقیت حذف شد.`, 'حذف اسلاید');

          this.remove_view.loading = false;
          this.remove_view.slide = false;
          this.remove_view.dialog = false;
          this.get_slides();

        }
      }).catch((error)=>{
        this.$snotify.error(`در حذف اسلاید مشکلی به وجود آمد. کد : ${error.response.status}`, 'حذف اسلاید');
        this.change_status_btn_loading = false;
      })
    },
    change_search_field(){
      this.search_items=this.slides_table.desserts;
    },
    create_slide (id){
      this.create_view.loading = true;
      let slide = new FormData();
      slide.append('img', this.create_view.slide.img);
      axios.post(`${this.BACKEND_LINK}/api/account-admin/home-slides/`,slide ,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        if(response.status === 201) {
          this.$snotify.success(`اسلاید با موفقیت ثبت شد.`, 'ثبت اسلاید');
          this.create_view.loading = false;
          this.create_view.slide = {img: null};
          this.create_view.dialog = false;

          this.get_slides();
        }
        else {
          this.$snotify.error(`در ثبت اسلاید مشکلی به وجود آمد. کد : ${response.status}`, 'ثبت اسلاید');
        }
        this.create_view.loading = false;
      }).catch((error)=>{
        this.$snotify.error(`در ثبت اسلاید مشکلی به وجود آمد. کد : ${error.response.status}`, 'ثبت اسلاید');
        this.create_view.loading = false;
      })
    },

  }
}
</script>
